import { StyleFill, StyleAnimation, StyleVoid } from "./styles";
import React from "react";

export const ProgressMiddleBar = ({ idx, step }) => {
  return step > idx ? <StyleFill /> : (step === idx ? <StyleAnimation /> : <StyleVoid />);
};